/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LeaderboardPositionDetailDto,
    LeaderboardPositionDetailDtoFromJSON,
    LeaderboardPositionDetailDtoFromJSONTyped,
    LeaderboardPositionDetailDtoToJSON,
} from './LeaderboardPositionDetailDto';
import {
    LeaderboardSymbolDto,
    LeaderboardSymbolDtoFromJSON,
    LeaderboardSymbolDtoFromJSONTyped,
    LeaderboardSymbolDtoToJSON,
} from './LeaderboardSymbolDto';
import {
    LeaderboardUserDto,
    LeaderboardUserDtoFromJSON,
    LeaderboardUserDtoFromJSONTyped,
    LeaderboardUserDtoToJSON,
} from './LeaderboardUserDto';

/**
 * 
 * @export
 * @interface LeaderboardDto
 */
export interface LeaderboardDto {
    /**
     * 
     * @type {Array<LeaderboardSymbolDto>}
     * @memberof LeaderboardDto
     */
    mostPurchasedSymbols: Array<LeaderboardSymbolDto>;
    /**
     * 
     * @type {Array<LeaderboardSymbolDto>}
     * @memberof LeaderboardDto
     */
    trendingSymbols: Array<LeaderboardSymbolDto>;
    /**
     * 
     * @type {Array<LeaderboardSymbolDto>}
     * @memberof LeaderboardDto
     */
    mostSoldSymbols: Array<LeaderboardSymbolDto>;
    /**
     * 
     * @type {Array<LeaderboardSymbolDto>}
     * @memberof LeaderboardDto
     */
    mostProfitableSymbols: Array<LeaderboardSymbolDto>;
    /**
     * 
     * @type {Array<LeaderboardUserDto>}
     * @memberof LeaderboardDto
     */
    mostYtdPerformanceUsers: Array<LeaderboardUserDto>;
    /**
     * 
     * @type {Array<LeaderboardUserDto>}
     * @memberof LeaderboardDto
     */
    mostYtdPerformanceCompetitorUsers: Array<LeaderboardUserDto>;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardDto
     */
    transactionAmountK: number;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardDto
     */
    investedValueM: number;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardDto
     */
    portfoliosValueM: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof LeaderboardDto
     */
    excludedUserIds: Array<string>;
    /**
     * 
     * @type {LeaderboardPositionDetailDto}
     * @memberof LeaderboardDto
     */
    profitabilityPosition?: LeaderboardPositionDetailDto | null;
    /**
     * 
     * @type {LeaderboardPositionDetailDto}
     * @memberof LeaderboardDto
     */
    investmentValuePosition?: LeaderboardPositionDetailDto | null;
    /**
     * 
     * @type {LeaderboardPositionDetailDto}
     * @memberof LeaderboardDto
     */
    transactionAmountPosition?: LeaderboardPositionDetailDto | null;
    /**
     * 
     * @type {LeaderboardPositionDetailDto}
     * @memberof LeaderboardDto
     */
    dividendYieldPosition?: LeaderboardPositionDetailDto | null;
    /**
     * 
     * @type {LeaderboardPositionDetailDto}
     * @memberof LeaderboardDto
     */
    ytdPerformancePosition?: LeaderboardPositionDetailDto | null;
}

export function LeaderboardDtoFromJSON(json: any): LeaderboardDto {
    return LeaderboardDtoFromJSONTyped(json, false);
}

export function LeaderboardDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mostPurchasedSymbols': ((json['mostPurchasedSymbols'] as Array<any>).map(LeaderboardSymbolDtoFromJSON)),
        'trendingSymbols': ((json['trendingSymbols'] as Array<any>).map(LeaderboardSymbolDtoFromJSON)),
        'mostSoldSymbols': ((json['mostSoldSymbols'] as Array<any>).map(LeaderboardSymbolDtoFromJSON)),
        'mostProfitableSymbols': ((json['mostProfitableSymbols'] as Array<any>).map(LeaderboardSymbolDtoFromJSON)),
        'mostYtdPerformanceUsers': ((json['mostYtdPerformanceUsers'] as Array<any>).map(LeaderboardUserDtoFromJSON)),
        'mostYtdPerformanceCompetitorUsers': ((json['mostYtdPerformanceCompetitorUsers'] as Array<any>).map(LeaderboardUserDtoFromJSON)),
        'transactionAmountK': json['transactionAmountK'],
        'investedValueM': json['investedValueM'],
        'portfoliosValueM': json['portfoliosValueM'],
        'excludedUserIds': json['excludedUserIds'],
        'profitabilityPosition': !exists(json, 'profitabilityPosition') ? undefined : LeaderboardPositionDetailDtoFromJSON(json['profitabilityPosition']),
        'investmentValuePosition': !exists(json, 'investmentValuePosition') ? undefined : LeaderboardPositionDetailDtoFromJSON(json['investmentValuePosition']),
        'transactionAmountPosition': !exists(json, 'transactionAmountPosition') ? undefined : LeaderboardPositionDetailDtoFromJSON(json['transactionAmountPosition']),
        'dividendYieldPosition': !exists(json, 'dividendYieldPosition') ? undefined : LeaderboardPositionDetailDtoFromJSON(json['dividendYieldPosition']),
        'ytdPerformancePosition': !exists(json, 'ytdPerformancePosition') ? undefined : LeaderboardPositionDetailDtoFromJSON(json['ytdPerformancePosition']),
    };
}

export function LeaderboardDtoToJSON(value?: LeaderboardDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mostPurchasedSymbols': ((value.mostPurchasedSymbols as Array<any>).map(LeaderboardSymbolDtoToJSON)),
        'trendingSymbols': ((value.trendingSymbols as Array<any>).map(LeaderboardSymbolDtoToJSON)),
        'mostSoldSymbols': ((value.mostSoldSymbols as Array<any>).map(LeaderboardSymbolDtoToJSON)),
        'mostProfitableSymbols': ((value.mostProfitableSymbols as Array<any>).map(LeaderboardSymbolDtoToJSON)),
        'mostYtdPerformanceUsers': ((value.mostYtdPerformanceUsers as Array<any>).map(LeaderboardUserDtoToJSON)),
        'mostYtdPerformanceCompetitorUsers': ((value.mostYtdPerformanceCompetitorUsers as Array<any>).map(LeaderboardUserDtoToJSON)),
        'transactionAmountK': value.transactionAmountK,
        'investedValueM': value.investedValueM,
        'portfoliosValueM': value.portfoliosValueM,
        'excludedUserIds': value.excludedUserIds,
        'profitabilityPosition': LeaderboardPositionDetailDtoToJSON(value.profitabilityPosition),
        'investmentValuePosition': LeaderboardPositionDetailDtoToJSON(value.investmentValuePosition),
        'transactionAmountPosition': LeaderboardPositionDetailDtoToJSON(value.transactionAmountPosition),
        'dividendYieldPosition': LeaderboardPositionDetailDtoToJSON(value.dividendYieldPosition),
        'ytdPerformancePosition': LeaderboardPositionDetailDtoToJSON(value.ytdPerformancePosition),
    };
}

